import { makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() => ({
  content: {
    '@media screen': {
      display: 'none',
    },

    '& .MuiTableCell-sizeSmall': {
      '@media print': {
        padding: '2px 4px',
      },
    },
  },
  defaultFontSize: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 14,
      },
    },
  },
  fontSize10Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 13,
      },
    },
  },
  fontSize11Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 12,
      },
    },
  },
  fontSize12Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 11,
      },
    },
  },
  fontSize13Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 10,
      },
    },
  },
  fontSize14Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 9,
      },
    },
  },
  fontSize15Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 8,
      },
    },
  },
  fontSize18Columns: {
    '& .MuiTableCell-root': {
      '@media print': {
        fontSize: 7,
      },
    },
  },
  printButton: {
    height: 56,
    fontWeight: 600,
    fontSize: 16,
    color: variables.richBlack,

    '& .MuiButton-root:hover': {
      backgroundColor: 'unset !important;',
    },
  },
  printBtnText: {
    marginInlineStart: 5,
  },
  title: {
    color: variables.black50,
    textAlign: 'start',
    fontWeight: 400,
    marginBottom: 10,
  },
}));
